import type { IFieldValidationParams } from '../validation.types';
import { ValidationErrorType } from '../validation.types';

const MIN_FIELD_CHANNEL_ALIAS_LENGTH = 2;
const CHANNEL_ALIAS_REGEXP = /^[a-zA-Z0-9-_]+$/;

export const channelAliasCreateValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  if (value?.length > 0 && value?.length < MIN_FIELD_CHANNEL_ALIAS_LENGTH) {
    return errorToText[ValidationErrorType.TooShort] || '';
  }

  if (!CHANNEL_ALIAS_REGEXP.test(value)) {
    return errorToText[ValidationErrorType.IncorrectSymbols] || '';
  }

  return null;
};

export const channelAliasEditValidation = ({
  value,
  errorToText,
}: IFieldValidationParams): string | null => {
  const createError = channelAliasCreateValidation({ value, errorToText });

  if (createError) {
    return createError;
  }

  if (!value || value.length === 0) {
    return errorToText[ValidationErrorType.Empty] || '';
  }

  return null;
};
